import React, { useState } from 'react';
import { companyDetailsLoader, companyElementTypesLoader, userLoader } from '../../actions/data_loaders';
import withDataLoaded from '../with_data_loaded';
import PageSpinner from '../shared/page_spinner';
import CompanyDetails from './company_details';
import CompanyDetailsAuditTable from './company_details_audit_table';
import { DeleteOutlined as DeleteOutlinedIcon, ExpandMore as ExpandMoreIcon, MoreVert } from '@mui/icons-material';
import Typography from '@mui/material/Typography';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Chip,
  IconButton,
  ListItemIcon,
  ListItemText,
  MenuItem,
} from '@mui/material';
import Menu from '@mui/material/Menu';
import FetchHelper from '../../helpers/fetch_helper';
import { useSelector } from 'react-redux';
import FunctionalityAccessHelper from '../../helpers/functionality_access_helper';
import Actions from '../../actions/actions';

function CompanyDetailsPage() {
  let [isAccordionOpen, setIsAccordionOpen] = useState(false);
  const companyInfo = useSelector((redux) => redux.company);
  const currentUser = useSelector((redux) => redux.user);
  const userFunctionalityAcls = useSelector((redux) => redux.userFunctionalityAcls);
  const isCompanyDisabled = companyInfo?.financingProducts?.length === 0;

  function AdditionalMenu() {
    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);
    const handleClick = (event) => {
      setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
      setAnchorEl(null);
    };

    const menuItems = [
      {
        id: 'deactivate-company-menu-item',
        disabled: !FunctionalityAccessHelper.hasACL(userFunctionalityAcls, 'DEACTIVATE_COMPANY') || isCompanyDisabled,
        icon: <DeleteOutlinedIcon fontSize="small" />,
        text: 'Deactivate Company',
        onClick: async () => {
          await Actions.requestModals({
            title: `Are you sure you want to deactivate this company?`,
            contents: (
              <div style={{ textAlign: 'start' }}>
                <p>
                  Deactivating the company will prevent any users from running new credit applications <br />
                </p>
              </div>
            ),
            cancelButtonText: 'Go Back',
            okButtonText: 'Deactivate',
            okClass: 'action-warning',
            // okClass: 'action-primary confirm-cancel action-info',
            modalID: 'qa-deactivate-company-modal',
            okID: 'qa-deactivate-company-confirm',
            cancelID: 'qa-deactivate-company-cancel',
            okProcess: async () => {
              await FetchHelper.fetchJson(`companies/${companyInfo?.company?.coid}`, {
                method: 'DELETE',
                version: '/v3',
              });

              await Actions.fetchCompanyWithAdmin(companyInfo?.company?.coid);
              Actions.setMessages('Company Deactivated');
            },
            cancelProcess: async () => {},
          });
        },
      },
    ];

    const hasActiveMenuItems = menuItems?.some((mItem) => !mItem?.disabled);

    return (
      <div>
        {hasActiveMenuItems && (
          <IconButton
            aria-label="more"
            id="long-button"
            aria-controls={open ? 'long-menu' : undefined}
            aria-expanded={open ? 'true' : undefined}
            aria-haspopup="true"
            onClick={handleClick}
          >
            <MoreVert />
          </IconButton>
        )}
        {currentUser.atype === 'CPF' && (
          <Menu
            id="long-menu"
            MenuListProps={{
              'aria-labelledby': 'long-button',
            }}
            anchorEl={anchorEl}
            open={open}
            onClose={handleClose}
            slotProps={{
              paper: {
                style: {
                  maxHeight: 45 * 4.5,
                  width: '20ch',
                },
              },
            }}
          >
            {menuItems.map((mItem, k) => (
              <MenuItem key={k} id={mItem?.id} onClick={mItem?.onClick} disabled={mItem?.disabled}>
                <ListItemIcon>{mItem?.icon}</ListItemIcon>
                <ListItemText>{mItem?.text}</ListItemText>
              </MenuItem>
            ))}
          </Menu>
        )}
      </div>
    );
  }

  return (
    <div className="admin-company-page" style={{ marginTop: '15px' }}>
      <div style={{ textAlign: 'left', width: '100%', display: 'flex', flexDirection: 'row' }}>
        <Typography variant="h5" id="company-title">
          <span>
            Company Details
            {isCompanyDisabled && <Chip style={{ marginLeft: '5px' }} label="Deactivated" color="error" size="small" />}
          </span>
        </Typography>{' '}
        <span style={{ marginLeft: 'auto' }}>
          {' '}
          <AdditionalMenu />
        </span>
      </div>

      <CompanyDetails />
      <br />
      <br />
      <div className="history-accordion" id={'history-section'} style={{ width: '100%' }}>
        <Accordion
          className="accordion-box"
          id="company-history-accordion"
          variant={'outlined'}
          expanded={isAccordionOpen}
          style={{ width: '100%' }}
          TransitionProps={{ unmountOnExit: true }}
        >
          <AccordionSummary
            id="company-history-accordion-title"
            expandIcon={<ExpandMoreIcon />}
            onClick={() => {
              setIsAccordionOpen(!isAccordionOpen);
            }}
          >
            <Typography variant="h5" id="company-title">
              History
            </Typography>
          </AccordionSummary>
          <AccordionDetails className="accordion-details">
            <CompanyDetailsAuditTable />
          </AccordionDetails>
        </Accordion>
      </div>
    </div>
  );
}

export default withDataLoaded({
  WithData: CompanyDetailsPage,
  WithoutData: PageSpinner,
  data: [userLoader, companyDetailsLoader, companyElementTypesLoader],
});
